var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex justify-center w-full py-6" },
    [
      _vm.pageLoading
        ? _c("div", { staticClass: "grid w-full h-128 place-items-center" }, [
            _c("div", { staticClass: "blum-loader" })
          ])
        : _vm.center
        ? _c("div", { staticClass: "flex flex-col w-full gap-5 max-w-180" }, [
            _c(
              "div",
              {
                staticClass:
                  "flex items-center justify-between w-full gap-3 px-6"
              },
              [
                _c("BlTextTitle3", { attrs: { text: "Center information" } }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "flex items-center gap-3" },
                  [
                    _vm.center.status === "active"
                      ? _c("BlInputButton", {
                          attrs: {
                            type: "outlined-error",
                            label: "Deactivate center"
                          },
                          on: {
                            clicked: function($event) {
                              _vm.deactivateOpened = true
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.center.status === "deactivated"
                      ? _c("BlInputButton", {
                          attrs: {
                            type: "outlined",
                            label: "Reactivate center"
                          },
                          on: {
                            clicked: function($event) {
                              _vm.reactivateOpened = true
                            }
                          }
                        })
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "relative" },
                      [
                        _c("BlInputButton", {
                          staticClass:
                            "flex items-center justify-center w-8 h-8 hover:bg-hover-state",
                          attrs: { type: "plain", icon: "dots-vertical" },
                          on: {
                            clicked: function($event) {
                              _vm.menuOpened = !_vm.menuOpened
                            }
                          }
                        }),
                        _vm._v(" "),
                        _vm.menuOpened
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "absolute right-0 z-50 flex flex-col gap-1 p-2 mt-2 border rounded bg-pure-white border-slate-400"
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "px-4 py-2 text-left transition-all duration-300 rounded cursor-pointer hover:bg-hover-state min-w-40",
                                    class: {
                                      "pointer-events-none bg-slate-300 opacity-25":
                                        _vm.isCurrentCenter
                                    },
                                    on: {
                                      click: function($event) {
                                        _vm.deleteOpened = true
                                      }
                                    }
                                  },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "text-error-400",
                                      attrs: { text: "Delete center" }
                                    })
                                  ],
                                  1
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full px-6 py-6 bg-pure-white rounded-2xl" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-between gap-3 mb-4"
                  },
                  [
                    _c("BlTextTitle4", { attrs: { text: "Center details" } }),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      attrs: { type: "outlined", label: "Edit" },
                      on: {
                        clicked: function($event) {
                          _vm.centerDetailsEditOpened = true
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.centerDetailsEditOpened
                      ? _c("EditCenterDetailsModal", {
                          on: {
                            "close-modal": function($event) {
                              _vm.centerDetailsEditOpened = false
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "grid grid-cols-6 gap-3" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Center name" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-4 text-slate-1000",
                      attrs: { text: _vm.center.name }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Status" }
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "flex col-span-4" },
                      [
                        _c("BlChip", {
                          attrs: { chip: _vm.center.status, dense: "" }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Date format" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-4 text-slate-1000",
                      attrs: { text: _vm.center.date_format }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Time zone" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-4 text-slate-1000",
                      attrs: { text: _vm.center.timezone }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Currency for Credits in Appointments" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-4 text-slate-1000",
                      attrs: {
                        text:
                          _vm.center.currency +
                          " (" +
                          _vm.center.currency_sym +
                          ")"
                      }
                    })
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full px-6 py-6 bg-pure-white rounded-2xl" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-between gap-3 mb-4"
                  },
                  [
                    _c("BlTextTitle4", { attrs: { text: "Team size limit" } }),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      attrs: { type: "outlined", label: "Adjust team size" },
                      on: {
                        clicked: function($event) {
                          _vm.teamSizeLimitEditOpened = true
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.teamSizeLimitEditOpened
                      ? _c("EditTeamSizeLimitModal", {
                          on: {
                            "close-modal": function($event) {
                              _vm.teamSizeLimitEditOpened = false
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "grid grid-cols-4 gap-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center gap-2 px-2 py-2 rounded bg-slate-200",
                      attrs: { title: "Total seat limit" }
                    },
                    [
                      _c("BlTextTitle3", {
                        attrs: {
                          text:
                            _vm.center.team_size_limit === null
                              ? "-"
                              : _vm.center.team_size_limit
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-full text-center truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: { text: "Total seat limit" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center gap-2 px-2 py-2 rounded bg-slate-200",
                      attrs: { title: "Total active member(s)" }
                    },
                    [
                      _c("BlTextTitle3", {
                        attrs: { text: _vm.center.total_active_members || 0 }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-full text-center truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: { text: "Total active member(s)" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center gap-2 px-2 py-2 rounded bg-slate-200",
                      attrs: { title: "Active therapist(s)" }
                    },
                    [
                      _c("BlTextTitle3", {
                        attrs: { text: _vm.center.total_active_therapists || 0 }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-full text-center truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: { text: "Active therapist(s)" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center gap-2 px-2 py-2 rounded bg-slate-200",
                      attrs: { title: "Active admin(s)" }
                    },
                    [
                      _c("BlTextTitle3", {
                        attrs: { text: _vm.center.total_active_admins || 0 }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-full text-center truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: { text: "Active admin(s)" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _vm.exceedTeamSizeLimits > 0
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "flex gap-2 px-4 py-2 mt-4 rounded bg-tulip-200"
                      },
                      [
                        _c("BlIcon", {
                          staticClass: "w-4 h-4 mt-1",
                          attrs: { icon: "warning", color: "tulip-7" }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          [
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-800",
                              attrs: {
                                text: "The current subscription is set to"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-800",
                              attrs: { text: _vm.center.team_size_limit || 0 }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-800",
                              attrs: { text: "seats, but there are" }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-800",
                              attrs: { text: _vm.center.total_active_members }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-800",
                              attrs: {
                                text: "active members, exceeding the limit by"
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-800",
                              attrs: {
                                text:
                                  _vm.center.total_active_members -
                                  (_vm.center.team_size_limit || 0) +
                                  "."
                              }
                            }),
                            _vm._v(" "),
                            _c("BlTextBody2", {
                              staticClass: "text-tulip-800",
                              attrs: {
                                text: "Please review the seat allocation."
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full px-6 py-6 bg-pure-white rounded-2xl" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-between gap-3 mb-4"
                  },
                  [_c("BlTextTitle4", { attrs: { text: "Manage features" } })],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "flex flex-col gap-2" }, [
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: { click: _vm.onChangeAnalytics }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.center.enable_analytics },
                          on: { changed: _vm.onChangeAnalytics }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "Analytics" } })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: { click: _vm.onChangeAppointments }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.center.enable_appointment },
                          on: { changed: _vm.onChangeAppointments }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "Availabilities & appointments" }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: { click: _vm.onChangeBranches }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.center.enable_branch },
                          on: { changed: _vm.onChangeBranches }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "Branches" } })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: { click: _vm.onChangeSalesPipeline }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.center.enable_sales_pipeline },
                          on: { changed: _vm.onChangeSalesPipeline }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", { attrs: { text: "Sales pipeline" } })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "flex" }, [
                    _c(
                      "div",
                      {
                        staticClass: "flex items-center gap-2 cursor-pointer",
                        on: { click: _vm.onChangeSbt }
                      },
                      [
                        _c("BlInputToggle", {
                          attrs: { checked: _vm.center.enable_sbt },
                          on: { changed: _vm.onChangeSbt }
                        }),
                        _vm._v(" "),
                        _c("BlTextBody2", {
                          attrs: { text: "Skill-based Treatment (SBT)" }
                        })
                      ],
                      1
                    )
                  ])
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full px-6 py-6 bg-pure-white rounded-2xl" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-between gap-3 mb-4"
                  },
                  [_c("BlTextTitle4", { attrs: { text: "Databank" } })],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticClass: "grid grid-cols-2 gap-3" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center gap-2 px-2 py-2 rounded bg-slate-200",
                      attrs: { title: "Total targets" }
                    },
                    [
                      _c("BlTextTitle3", {
                        attrs: { text: _vm.center.total_targets || 0 }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-full text-center truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: { text: "Total targets" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "flex flex-col items-center gap-2 px-2 py-2 rounded bg-slate-200",
                      attrs: { title: "Total curricula" }
                    },
                    [
                      _c("BlTextTitle3", {
                        attrs: { text: _vm.center.total_curricula || 0 }
                      }),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "w-full text-center truncate" },
                        [
                          _c("BlTextBody2", {
                            staticClass: "text-slate-700",
                            attrs: { text: "Total curricula" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "w-full px-6 py-6 bg-pure-white rounded-2xl" },
              [
                _c(
                  "div",
                  {
                    staticClass: "flex items-center justify-between gap-3 mb-4"
                  },
                  [
                    _c("BlTextTitle4", {
                      attrs: { text: "Contact information" }
                    }),
                    _vm._v(" "),
                    _c("BlInputButton", {
                      attrs: { type: "outlined", label: "Edit" },
                      on: {
                        clicked: function($event) {
                          _vm.contactInformationEditOpened = true
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.contactInformationEditOpened
                      ? _c("EditContactInformationModal", {
                          on: {
                            "close-modal": function($event) {
                              _vm.contactInformationEditOpened = false
                            }
                          }
                        })
                      : _vm._e()
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "grid grid-cols-6 gap-3" },
                  [
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Contact person name" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-4 text-slate-1000",
                      attrs: { text: _vm.center.contact_name || "-" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Email" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-4 text-slate-1000",
                      attrs: { text: _vm.center.contact_email || "-" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Phone number" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-4 text-slate-1000",
                      attrs: { text: _vm.center.contact_phone_number || "-" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-2 text-slate-700",
                      attrs: { text: "Center address" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "col-span-4 text-slate-1000",
                      attrs: { text: _vm.center.center_address || "-" }
                    })
                  ],
                  1
                )
              ]
            )
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.copyDatabank
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title:
                  "" +
                  (_vm.submitLoading
                    ? "Copying..."
                    : "Select databank to copy"),
                label:
                  "" +
                  (_vm.submitLoading
                    ? "Copying..."
                    : "Copy " + _vm.selectedCount + " databank(s)"),
                submitLoading: _vm.submitLoading,
                disabled: _vm.isDisabledSubmit
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.copyDatabank = false
                },
                "backdrop-action": _vm.onCopyDatabank
              }
            },
            [
              _c("div", { staticClass: "px-8" }, [
                _vm.submitLoading
                  ? _c("div", [
                      _c(
                        "div",
                        {
                          staticClass:
                            "relative flex items-center justify-center py-2"
                        },
                        [
                          _c(
                            "div",
                            [
                              _c("BlTextBody2", {
                                attrs: {
                                  text:
                                    "The copying process is underway. Please wait patiently while the operation completes."
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ])
                  : _c("div", [
                      _c(
                        "div",
                        { staticClass: "relative flex items-center px-2" },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.query,
                                expression: "query"
                              }
                            ],
                            staticClass:
                              "flex-shrink-0 w-full px-4 py-2 text-sm border rounded outline-none border-grey-200 focus:border-light-purple",
                            attrs: { type: "text", placeholder: "Search ..." },
                            domProps: { value: _vm.query },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.query = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("BlIcon", {
                            staticClass: "absolute w-6 right-4",
                            attrs: { icon: "search" }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.filteredOptions.length === 0
                        ? _c(
                            "div",
                            {
                              staticClass:
                                "relative flex items-center justify-center px-4 py-2"
                            },
                            [
                              _c("BlTextBody2", {
                                attrs: { text: "Option not found" }
                              })
                            ],
                            1
                          )
                        : _c(
                            "div",
                            { staticClass: "px-2 mt-5 bl-input-dropdown-body" },
                            _vm._l(_vm.filteredOptions, function(option) {
                              return _c(
                                "div",
                                {
                                  key: option.id,
                                  staticClass: "bl-input-dropdown-option",
                                  on: {
                                    click: function($event) {
                                      return _vm.onChangeValue(option)
                                    }
                                  }
                                },
                                [
                                  _c("BlInputCheck", {
                                    staticClass:
                                      "flex-shrink-0 pointer-events-none",
                                    attrs: {
                                      checked: _vm.isOptionSelected(option)
                                    }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      staticClass:
                                        "bl-input-dropdown-option-name line-clamp-2"
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "font-bold",
                                          style: { color: "#475467" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(
                                                option.label ||
                                                  option.name ||
                                                  option
                                              ) +
                                              "\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "flex items-center gap-2",
                                          style: { color: "#475467" }
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(option.total_targets) +
                                              " target(s)\n                "
                                          ),
                                          _c("div", {
                                            staticClass:
                                              "w-2 h-2 rounded-full ",
                                            style: {
                                              backgroundColor: "#98A2B3"
                                            }
                                          }),
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(option.total_curriculums) +
                                              " curricula\n              "
                                          )
                                        ]
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            }),
                            0
                          )
                    ])
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.resetDatabank
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title:
                  "" + (_vm.submitLoading ? "Resetting..." : "Reset databank"),
                label:
                  "" + (_vm.submitLoading ? "Resetting..." : "Reset databank"),
                type: "error",
                submitLoading: _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.resetDatabank = false
                },
                "backdrop-action": _vm.onResetDatabank
              }
            },
            [
              _c("div", { staticClass: "px-8" }, [
                _vm.submitLoading
                  ? _c(
                      "div",
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "The databank reset process is underway. This may take some time. Please be patient while the operation completes."
                          }
                        })
                      ],
                      1
                    )
                  : _c(
                      "div",
                      [
                        _c("BlTextBody2", {
                          attrs: {
                            text:
                              "You are about to reset the databank for this center. By proceeding, all targets in the databank will be permanently deleted. This action is irreversible and cannot be undone."
                          }
                        })
                      ],
                      1
                    )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deactivateOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Deactivate center",
                label: "Deactivate center",
                type: "error",
                submitLoading: _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deactivateOpened = false
                },
                "backdrop-action": _vm.onDeactivate
              }
            },
            [
              _c("div", { staticClass: "px-8" }, [
                _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "You are about to deactivate the center" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "font-bold",
                      attrs: { text: _vm.center.name + "." }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "By deactivating this center," }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "all users within the center will lose access to Blüm immediately."
                      }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: { text: "Do you wish to proceed?" }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.reactivateOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Reactivate center",
                label: "Reactivate center",
                submitLoading: _vm.submitLoading,
                maxWidth: "40rem"
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.reactivateOpened = false
                },
                "backdrop-action": _vm.onReactivate
              }
            },
            [
              _c("div", { staticClass: "px-8" }, [
                _c(
                  "div",
                  { staticClass: "mb-2" },
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "You are about to reactivate the center" }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      staticClass: "font-bold",
                      attrs: { text: _vm.center.name + "." }
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  [
                    _c("BlTextBody2", {
                      attrs: { text: "By reactivating this center," }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: {
                        text:
                          "all users within the center will immediately regain access to Blüm."
                      }
                    }),
                    _vm._v(" "),
                    _c("BlTextBody2", {
                      attrs: { text: "Do you wish to proceed?" }
                    })
                  ],
                  1
                )
              ])
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Delete center",
                label: "Delete center",
                type: "error",
                submitLoading: _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.deleteOpened = false
                },
                "backdrop-action": _vm.onDelete
              }
            },
            [
              _c(
                "div",
                { staticClass: "px-8" },
                [
                  _c("BlTextBody2", { attrs: { text: "By deleting" } }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    staticClass: "font-bold",
                    attrs: { text: "" + _vm.center.name }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "all data associated with it will be lost," }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: {
                      text:
                        "and users will no longer be able to access the center."
                    }
                  }),
                  _vm._v(" "),
                  _c("BlTextBody2", {
                    attrs: { text: "This action cannot be undone." }
                  })
                ],
                1
              )
            ]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-46d5d978", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46d5d978","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/superAdmin/center/CenterInformation.vue
// module id = null
// module chunks = 